import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/error'
  },
  {
    path: '/error',
    component: () => import('@/views/error/index.vue')
  },
  {
    path: '/article',
    component: () => import('@/views/article/index')
  },
  {
    path: '/picture',
    component: () => import('@/views/picture/index')
  },
  {
    path: '/book',
    component: () => import('@/views/book/index')
  },
  {
    path: '/periodical',
    component: () => import('@/views/periodical/index')
  },
  {
    path: '/author',
    component: () => import('@/views/author/index')
  },
  {
    path: '/guide',
    component: () => import('@/views/guide/index')
  },
  {
    path: '/updown',
    component: () => import('@/views/downXian.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

export default router
